var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"clearable":""},model:{value:(_vm.educationCode),callback:function ($$v) {_vm.educationCode=$$v},expression:"educationCode"}},_vm._l((_vm.educationList),function(item){return _c('el-option',{key:item.dictCode,attrs:{"label":item.dictName,"value":item.dictCode}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }